;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';

function QuoteIcon({ className, fill = '#717f8a' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40.8" height="33.759" viewBox="0 0 40.8 33.759" className={className || ''}>
      <g id="quotes" transform="translate(-54.5 -62.3)">
        <path
          id="Path_90"
          data-name="Path 90"
          d="M54.5,82.879c0-9.029,4.51-16.069,14.082-20.579l3.249,6.682c-5.78,2.531-8.669,6.139-8.669,11.467a3.015,3.015,0,0,1,.9-.092c4.335,0,7.759,2.89,7.759,7.4,0,5.053-3.249,8.3-7.759,8.3C57.749,96.059,54.5,91.181,54.5,82.879Zm23.469,0c0-9.029,4.51-16.069,14.082-20.579L95.3,68.982c-5.78,2.531-8.669,6.139-8.669,11.467a3.015,3.015,0,0,1,.9-.092c4.335,0,7.767,2.89,7.767,7.4,0,5.053-3.249,8.3-7.767,8.3C81.218,96.059,77.969,91.181,77.969,82.879Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
export default QuoteIcon;
